'use client';

import { useEffect } from 'react';

const AGENT_META: Record<string, { emoji: string; color: string; label: string }> = {
  poby:  { emoji: '🐻', color: '#ff9a3d', label: 'Poby [Master]' },
  dony:  { emoji: '🏠', color: '#10b981', label: 'Dony [Resource]' },
  jessi: { emoji: '👩‍💻', color: '#ec4899', label: 'Jessi [Code]' },
  shon:  { emoji: '🔧', color: '#ff4d4d', label: 'Shon [Orchestrator]' },
  benny: { emoji: '🍏', color: '#3b82f6', label: 'Benny [Analyst]' },
  meety: { emoji: '💻', color: '#a855f7', label: 'Meety [Support]' },
  tony:  { emoji: '🪟', color: '#eab308', label: 'Tony [CAD/PPT]' },
  roony: { emoji: '🦿', color: '#8b5cf6', label: 'Roony [MCP-Hub]' },
  rudy:  { emoji: '👑', color: '#f59e0b', label: 'Rudy [Design]' },
};

const AGENT_ALIASES: Record<string, string> = {
  'poby-macstudio': 'poby',
  'ben-macbookair-1': 'benny',
  'gyungchul-macmini': 'jessi',
  'imac-imac': 'dony',
  'cindy-1': 'shon',
  cindydesk: 'tony',
  'insight-book': 'meety',
  'ben-imac21-imac': 'roony',
  'rudy-desktop': 'rudy',
  snapgrid_codex_bot: 'poby',
};

function normalizeAgentId(value: string | null | undefined): string {
  const id = (value || '').trim().toLowerCase();
  return AGENT_META[id] ? id : AGENT_ALIASES[id] || '';
}

export function DynamicFavicon() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hostname = window.location.hostname;
    const searchParams = new URLSearchParams(window.location.search);
    
    // 1. 도메인 또는 쿼리 파라미터로부터 에이전트 식별
    let detectedAgent = '';
    
    // 서브도메인 감지 (예: poby.snapcodex.com -> poby)
    const firstSub = hostname.split('.')[0].toLowerCase();
    detectedAgent =
      normalizeAgentId(searchParams.get('agent')) ||
      normalizeAgentId(searchParams.get('agentId')) ||
      normalizeAgentId(firstSub) ||
      normalizeAgentId(window.localStorage.getItem('snapgrid.agentId')) ||
      normalizeAgentId(window.localStorage.getItem('snapgrid_agent_id'));

    if (detectedAgent) {
      const meta = AGENT_META[detectedAgent];
      
      // 2. 탭 아이디(타이틀) 동적 적용
      document.title = `${meta.emoji} ${meta.label} | SnapGRID`;

      // 3. 파비콘 SVG 데이터 URI 생성 및 적용
      // 둥근 사각형 배경 위에 이모지를 정렬하여 수려한 디자인 제공
      const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" rx="24" fill="${meta.color}"/><text y="74" x="14" font-size="68">${meta.emoji}</text></svg>`;
      const dataUri = `data:image/svg+xml;utf8,${encodeURIComponent(svgContent)}`;

      // 기존 favicon 링크 태그 교체 또는 신규 생성
      let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = dataUri;
      link.type = 'image/svg+xml';

      let themeColor: HTMLMetaElement | null = document.querySelector("meta[name='theme-color']");
      if (!themeColor) {
        themeColor = document.createElement('meta');
        themeColor.name = 'theme-color';
        document.head.appendChild(themeColor);
      }
      themeColor.content = meta.color;
      
      // Apple touch icon 도 동시 갱신
      let appleLink: HTMLLinkElement | null = document.querySelector("link[rel='apple-touch-icon']");
      if (!appleLink) {
        appleLink = document.createElement('link');
        appleLink.rel = 'apple-touch-icon';
        document.getElementsByTagName('head')[0].appendChild(appleLink);
      }
      appleLink.href = dataUri;
    }
  }, []);

  return null;
}
